import { CONSUMER_PRO_DISPLAY_PRICES } from '../../../packs/constants/pricingPlanTiers.constants';
import { MAX_GAMES_PER_CHALLENGE_PRO } from '../../../create/constants/create.constants';

/** Mirrors the server cap CONSUMER_GROUP_PRO_MEMBER_CAP (server/src/constants/groups.constants.js). Keep both in sync. */
export const PRO_GROUP_MEMBER_CAP = 100;

// Only perks that are actually enforced today. "Zero ads" was dropped until ads ship —
// there is nothing to be ad-free from yet (no ad SDK in the app).
export const PRO_PERKS = [
  { key: 'predictions', label: 'Every prediction type' },
  { key: 'picks', label: `Up to ${MAX_GAMES_PER_CHALLENGE_PRO} picks per challenge` },
  { key: 'groups', label: `Groups up to ${PRO_GROUP_MEMBER_CAP} members` },
] as const;

function parsePriceToNumber(label: string): number {
  return parseFloat(label.replace(/[^0-9.]/g, ''));
}

const monthlyNum = parsePriceToNumber(CONSUMER_PRO_DISPLAY_PRICES.MONTHLY_LABEL); // 7.90
const yearlyNum = parsePriceToNumber(CONSUMER_PRO_DISPLAY_PRICES.YEARLY_LABEL);   // 59.90

/** Monthly price in cents (for count-up animation) */
export const PRO_MONTHLY_CENTS = Math.round(monthlyNum * 100); // 790
/** Yearly-equivalent monthly price in cents (for count-up animation) */
export const PRO_YEARLY_MONTHLY_CENTS = Math.round((yearlyNum / 12) * 100); // 499
/** Yearly total price string */
export const PRO_YEARLY_LABEL = CONSUMER_PRO_DISPLAY_PRICES.YEARLY_LABEL; // '$59.90'
/** Percentage saved on yearly vs monthly */
export const PRO_YEARLY_SAVE_PCT = Math.round(
  ((monthlyNum * 12 - yearlyNum) / (monthlyNum * 12)) * 100,
); // 37
